import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../useAuth';
import dashboardController, {
  SalesDashboardJobDetails,
} from '../../services/api/dashboardController';

type AuthLike = { tokens?: { idToken?: { jwtToken?: string } } };

export const useSalesJobDetails = (displayJobId: string) => {
  const auth = useAuth();
  const authToken = (auth as AuthLike)?.tokens?.idToken?.jwtToken ?? '';

  return useQuery<SalesDashboardJobDetails>({
    queryKey: ['salesJobDetails', displayJobId],
    queryFn: async () => {
      const response = await dashboardController.getSalesJobDetails(
        displayJobId,
        authToken,
      );
      return response?.data;
    },
    enabled: Boolean(displayJobId && authToken),
  });
};
